<template>
  <div>
    <!--show information when page is loaded-->
    <div v-if="pageReady">
      <!--STUDENT INFO PANEL-->
      <v-flex xs12 text-xs-left>
        <v-layout row wrap>
          <v-icon color="secondary">mdi-account-card-details</v-icon>
          <h3 class="header-class">Student Info</h3>
        </v-layout>
        <div :class="{ mobile: isMobile, desktop: !isMobile }">
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Name:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.studentFirstName }}
              {{ submissionData.studentLastName }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">ID:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.studentExtId }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">School:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.studentSchoolName }} ({{ submissionData.schoolCode}})
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Gender:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.gender }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Grade:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.grade }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Birthdate:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.birthDate | formatDate }}
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-divider class="divider-class" />

      <!--SERVICE INFO PANEL-->
      <v-flex xs12 text-xs-left>
        <v-layout row wrap>
          <v-icon color="secondary">mdi-file-document</v-icon>
          <h3 class="header-class">Service Info</h3>
        </v-layout>
        <div :class="{ mobile: isMobile, desktop: !isMobile }">
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Service Type:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.planTypeName }}: {{ submissionData.serviceType }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">
              <span v-if="isMobile">Proj. Start Date:</span>
              <span v-else>Projected Start Date:</span>
            </v-flex>
            <v-flex xs7 md9>
              {{ submissionData.serviceStartDate | formatDate }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">
              <span v-if="isMobile">Proj. End Date:</span>
              <span v-else>Projected End Date:</span>
            </v-flex>
            <v-flex xs7 md9>
              {{ submissionData.serviceEndDate | formatDate }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Frequency:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.frequency }}
              <span v-if="submissionData.serviceEsy">(ESY)</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Service Provider:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.providerFirstName + ' ' + submissionData.providerLastName }}
              <span v-if="submissionData.providerCredential">
                /
                {{ submissionData.providerCredential }}
              </span>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-divider class="divider-class" />

      <!--SESSION INFO PANEL-->
      <v-flex xs12 text-xs-left>
        <v-layout row wrap>
          <v-icon color="secondary">mdi-calendar-text</v-icon>
          <h3 class="header-class">Session Info</h3>
        </v-layout>
        <div :class="{ mobile: isMobile, desktop: !isMobile }">
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Session Date:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.sessionDate | formatDate }}
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!isAbsent && submissionData.serviceDelivered" required: false>
            <v-flex xs5 md3 class="data-title">Service Delivered:</v-flex>
            <v-flex xs7 md9>
              <span style="word-wrap: break-word">{{ submissionData.serviceDeliveredName }}</span>
            </v-flex>
          </v-layout>
          <v-layout v-if="!hideFields" row wrap>
            <v-flex xs5 md3 class="data-title">Start Time (Length):</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.sessionTime | militaryTimeToStandard }}
              ({{ submissionData.sessionMinutes }} mins)
            </v-flex>
          </v-layout>
          <v-layout v-if="hideFields" row wrap>
            <v-flex xs5 md3 class="data-title">Absent Type:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.absentTypeName }}
            </v-flex>
          </v-layout>
          <v-layout v-if="hideFields && submissionData.studentAbsentReasonName" row wrap>
            <v-flex xs5 md3 class="data-title">Absent Reason:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.studentAbsentReasonName }}
            </v-flex>
          </v-layout>
          <v-layout v-if="hideFields && submissionData.absentAlternativeName" row wrap>
            <v-flex xs5 md3 class="data-title">Absent Alternative:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.absentAlternativeName }}
            </v-flex>
          </v-layout>
          <v-layout v-if="hideFields && submissionData.absentAlternativeDesc" row wrap>
            <v-flex xs5 md3 class="data-title">Absent Alternative Desc:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.absentAlternativeDesc }}
            </v-flex>
          </v-layout>
          <v-layout v-if="hideFields && (submissionData.noServiceNotifFlag !== null)" row wrap>
            <v-flex xs5 md3 class="data-title">Parents Informed:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.noServiceNotifFlagName }}
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5 md3 class="data-title">Location:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.locationName }}
              <span v-if="submissionData.locationOther"> - {{ submissionData.locationOther}}</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!hideFields && isGroup">
            <v-flex xs5 md3 class="data-title">Group Type:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.groupTypeName }}
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!hideFields && !isConSultationService && submissionData.groupSize">
            <v-flex xs5 md3 class="data-title">Group Size:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.groupSize }}
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!hideFields && submissionData.deliveryModeName">
            <v-flex xs5 md3 class="data-title">Delivery Mode:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.deliveryModeName }}
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!hideFields && submissionData.roomName">
            <v-flex xs5 md3 class="data-title">Classroom Number:</v-flex>
            <v-flex xs7 md9>
              {{ submissionData.roomName }}
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!isAbsent && submissionData.providerLocation">
            <v-flex xs5 md3 class="data-title">Provider Location:</v-flex>
            <v-flex xs7 md9>
              <span style="word-wrap: break-word">{{ submissionData.providerLocation }}</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="!hideFields && submissionData.notes">
            <v-flex xs5 md3 class="data-title">Comments:</v-flex>
            <v-flex xs7 md9>
              <span style="word-wrap: break-word">{{ submissionData.notes }}</span>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-divider class="divider-class" />

      <!--MEDICAID REIMBURSABLE PANEL-->
      <v-flex v-if="!hideFields && !isAbsent && !isConSultationService" xs12 text-xs-left>
        <v-layout row wrap>
          <v-icon color="secondary">mdi-calendar-plus</v-icon>
          <h3 class="header-class">Documentation of Service and Student Performance</h3>
        </v-layout>
        <div :class="{ mobile: isMobile, desktop: !isMobile }">
          <v-layout row wrap >
            <v-flex xs12 sm5 md4 class="data-title">
              <span v-if="isMobile">Total Reimb. Mins:</span>
              <span v-else>Total Reimbursable Minutes:</span>
            </v-flex>
            <v-flex xs12 sm7 md8>
              {{ submissionData.medicaidMinutes }} mins
            </v-flex>
          </v-layout>
          <!--repeatable medicaidSessions-->
          <div v-if="submissionData.medicaidSessions.length">
            <div v-for="(session, index) in submissionData.medicaidSessions"
                 class="session-container"
                 :key="index">
              <v-divider />
              <v-layout row wrap class="session-row">
                <v-flex xs12 sm5 md4 class="data-title">Minutes:</v-flex>
                <v-flex xs12 sm7 md8>
                  {{ session.minutes }} mins
                </v-flex>
              </v-layout>
              <v-layout row wrap class="session-row">
                <v-flex xs12 sm5 md4 class="data-title">Procedure Description:</v-flex>
                <v-flex xs12 sm7 md8>
                  {{ session.procedureName }}
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
        <v-divider v-if="!hideFields && !isConSultationService" class="divider-class"/>
      </v-flex>
      <!--SESSION INFO 2 PANEL-->
      <v-flex v-if="!isAbsent" xs12 text-xs-left>
        <div :class="{ mobile: isMobile, desktop: !isMobile }">
          <v-spacer>
          <v-layout v-if="!hideFields && !isConSultationService" row wrap class>
            <v-flex style="padding-bottom: 10px;" xs12 sm5 md4 class="data-title">Relevant Student Behavior:</v-flex>
            <v-flex xs12 sm7 md8 class="behavior-container">
              {{ displaySessionValues(submissionData.ptSessionBehaviors) }}
            </v-flex>
            <v-flex md3 />
          </v-layout>
          <v-layout v-if="!hideFields && !isConSultationService" row wrap class>
            <v-flex style="padding-bottom: 10px;" xs12 sm5 md4 class="data-title">Relevant Student Behavior Details:</v-flex>
            <v-flex xs12 sm7 md8 style="padding-bottom: 15px;" class="behavior-container">
              {{ submissionData.studentBehavior }}
            </v-flex>
            <v-flex/>
          </v-layout>
          <v-divider class="divider-half-class" v-if="!isConSultationService"/>
          <v-flex xs12 text-xs-left v-if="!hideFields" v-for="(objective, i) in submissionData.ptSessionObjectives" :key="i">
            <v-layout v-if="!hideFields" row wrap class>
              <v-flex style="padding-bottom: 15px;" xs12 sm5 md4 class="data-title">Objective:</v-flex>
              <v-flex v-if="objective.value !== 'OTHER'" style="padding-bottom: 15px;" xs12 sm7 md8 class="objectivenote-container">
                {{ objective.name }}
              </v-flex>
              <v-flex v-if="objective.value === 'OTHER'" style="padding-bottom: 15px;" xs12 sm7 md8 class="objectivenote-container">
                {{ objective.name + ': ' + objective.objectiveOther }}
              </v-flex>
            </v-layout>
            <v-layout v-if="!hideFields" row wrap class>
              <v-flex style="padding-bottom: 15px;" xs12 sm5 md4 class="data-title">Implementations:</v-flex>
              <v-flex xs12 sm7 md8 class="objectivenote-container">
                {{ formatImplementationValues(submissionData.ptSessionObjectiveImplementation, objective.id) }}
              </v-flex>
            </v-layout>
            <v-divider v-if="submissionData.ptSessionObjectives.length > 1" class="divider-half-class"/>
          </v-flex>
          <v-layout v-if="!hideFields" row wrap class>
            <v-flex style="padding-bottom: 10px;" xs12 sm5 md4 class="data-title">Objective Details:</v-flex>
            <v-flex xs12 sm7 md8 class="progressAssessment-container">
              {{ submissionData.objectiveNotes }}
            </v-flex>
          </v-layout>
          <v-divider class="divider-half-class"/>
          <v-flex xs12 text-xs-left v-if="!hideFields && !isConSultationService" v-for="(progressCodes, i) in submissionData.ptSessionProgresses" :key="i">
            <v-layout v-if="!hideFields" row wrap class>
              <v-flex style="padding-bottom: 10px;" xs12 sm5 md4 class="data-title">Task:</v-flex>
              <v-flex xs12 sm7 md8 class="objectivenote-container">
                {{ progressCodes.task }}
              </v-flex>
            </v-layout>
            <v-layout v-if="!hideFields" row wrap class>
              <v-flex style="padding-bottom: 5px; padding-left: 15px;" xs12 sm5 md4 class="data-title">Measurable Data:</v-flex>
              <v-flex xs12 sm12 md12 :style="{'padding-left': !isMobile ? '280px' : '50px', 'padding-bottom': '1px' }" v-for="(progressMeasure, index) in submissionData.ptSessionProgressMeasures" :key="index">
                {{ formatProgressMeasures([progressMeasure], progressCodes.id) }}
              </v-flex>
            </v-layout>
            <v-layout v-if="!hideFields" row wrap class>
              <v-flex style="padding-bottom: 5px; padding-left: 15px;" xs12 sm5 md4 class="data-title">Level of Assistance:</v-flex>
              <v-flex xs12 sm12 md12 :style="{'padding-left': !isMobile ? '280px' : '50px', 'padding-bottom': '1px' }" v-for="(assistance, index) in submissionData.ptSessionProgressAssistance" :key="index">
                {{ formatProgressAssistance([assistance], progressCodes.id) }}
              </v-flex>
            </v-layout>
            <v-layout v-if="!hideFields" row wrap class>
              <v-flex style="padding-bottom: 5px; padding-left: 15px;" xs12 sm5 md4 class="data-title">Type of Assistance:</v-flex>
              <v-flex xs12 sm12 md12 :style="{'padding-left': !isMobile ? '280px' : '50px', 'padding-bottom': '1px' }" v-for="(type, index) in submissionData.ptSessionProgressTypes" :key="index">
                {{ formatProgressTypes([type], progressCodes.id) }}
              </v-flex>
            </v-layout>
            <v-divider v-if="submissionData.ptSessionProgressTypes.length > 1" class="divider-half-class"/>
          </v-flex>
          <v-layout v-if="!hideFields  && !isConSultationService" row wrap class>
            <v-flex style="padding-bottom: 15px;" xs12 sm5 md4 class="data-title">Performance/Progress Notes:</v-flex>
            <v-flex xs12 sm7 md8 style="padding-bottom: 15px;" class="behavior-container">
              {{ submissionData.progressAssessment }}
            </v-flex>
            <v-flex/>
          </v-layout>
          <v-layout v-if="!hideFields" row wrap class>
            <v-flex style="padding-bottom: 15px;" xs12 sm5 md4 class="data-title">Next Session Focus(es):</v-flex>
            <v-flex xs12 sm7 md8 style="padding-bottom: 15px;" class="behavior-container">
              {{ submissionData.nextSessionFocus }}
            </v-flex>
            <v-flex/>
          </v-layout>
          <v-layout v-if="!hideFields" row wrap class>
            <v-flex style="padding-bottom: 15px;" xs12 sm5 md4 class="data-title">Next Session Goal(s):</v-flex>
            <v-flex xs12 sm7 md8 style="padding-bottom: 15px;" class="behavior-container">
              {{ submissionData.nextSessionGoal }}
            </v-flex>
            <v-flex/>
          </v-layout>
          <v-layout v-if="!hideFields" row wrap class>
            <v-flex style="padding-bottom: 15px;" xs12 sm5 md4 class="data-title">Session Notes:</v-flex>
            <v-flex xs12 sm7 md8 style="padding-bottom: 15px;" class="behavior-container">
              {{ submissionData.sessionNotes }}
            </v-flex>
            <v-flex/>
          </v-layout>
          </v-spacer>
        </div>
        <v-divider v-if="!hideFields" class="divider-class" />
      </v-flex>
      <!--Supervisor Signature w/ verification PANEL-->
      <v-flex xs12 text-xs-left>
        <div v-if="submissionData.credentialType != 'PT' && submissionData.supervisorName">
        <div :class="{ mobile: isMobile, desktop: !isMobile }">
          <v-spacer>
          <v-layout row wrap class>
            <v-flex xs12 sm5 md3 class="data-title">Supervision Signature:</v-flex>
            <v-flex xs12 sm7 md9 class="behavior-container">
              {{ submissionData.supervisorName + " / " + submissionData.supervisorCredential + ", " + convertDisplayedDate(submissionData.supervisorDate) }}
            </v-flex>
            <v-flex md3 />
          </v-layout>
          </v-spacer>
        </div>
        <v-divider class="divider-class" />
        </div>
      </v-flex>
      <!--Supervisor Signature w/o verification PANEL-->
      <v-flex xs12 text-xs-left>
        <div v-if="submissionData.credentialType != 'PT' && !submissionData.supervisorName">
        <div :class="{ mobile: isMobile, desktop: !isMobile }">
          <v-spacer>
          <v-layout row wrap class>
            <v-flex xs12 sm5 md3 class="data-title">Supervision Signature:</v-flex>
            <v-flex xs12 sm7 md9 class="behavior-container">
              {{ "Not Completed" }}
            </v-flex>
            <v-flex md3 />
          </v-layout>
          </v-spacer>
        </div>
        <v-divider class="divider-class" />
        </div>
      </v-flex>
      <!--AUDIT LOG PANEL-->
      <v-flex xs12 text-xs-left>
        <v-layout row wrap>
          <v-icon color="secondary">mdi-timer</v-icon>
          <h3 class="header-class">Audit Log</h3>
        </v-layout>
        <div :class="{ mobile: isMobile, desktop: !isMobile }">
          <div v-for="(log, index) in submissionData.logs"
               :key="index">
            {{ log.username }}<br>
            <small>{{ log.updateName }} {{ log.updatedDate | formatDateWithTime }}</small>
          </div>
        </div>
      </v-flex>
    </div>
    <!--show loading if app isnt ready-->
    <div v-if="!pageReady" class="text-xs-center">
      <loading-spinner />
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants';
import api from '@/utils/api';
import ActionIcons from '@/components/action-icons';
import LoadingSpinner from '@/components/loading-spinner';
import JWTHelper from '@/jwt-token';
/* eslint-disable */

export default {
  name: 'ConfirmationPage',
  props: ['dialog', 'submission'],
  components: {
    ActionIcons,
    LoadingSpinner
  },
  computed: {
    isConSultationService() {
      return Constants.IS_CONSULTATION_SERVICE(this.submissionData);
    },
    isAbsent() {
      return this.submissionData.absentType;
    },
    isGroup() {
      return this.submissionData.groupType === Constants.SERVICE_LOG.GROUP_TYPE.GROUP;
    },
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  data() {
    return {
      credentialType: JWTHelper.credType(),
      errorMsg: null,
      hideFields: false,
      pageReady: false,
      showLoading: false,
      submissionData: null
    };
  },
  methods: {
    loadPage() {
      this.pageReady = false;
      api.get(Constants.PTSL_GET_PT_SESSION_URL(this.submission.sessionId))
        .then((results) => {
          this.submissionData = results.data.data;
          if (Constants.IS_ABSENT(this.submissionData.absentType)) this.hideFields = true;
        })
        .catch((error) => {
          this.errorMsg = error.message;
        })
        .finally(() => {
          this.pageReady = true;
        });
    },
    convertDisplayedDate(date) {
      const year = date.substring(0, 4);
      const month = date.substring(5, 7);
      const day = date.substring(8, 10);
      // eslint-disable-next-line
      return month + '/' + day + '/' + year;
    },
    displaySessionValues(values) {
      if (values === null || values === undefined) return '';
      return values.map((value) => { return value.name }).join(', ');
    },
    // TODO: fix the values not having ', ' inbetween
    formatImplementationValues(values, objectiveId) {
      if (!Array.isArray(values)) return '';

      const filteredValues = values
        .filter((value) => {
          if (Array.isArray(value)) {
            return value.some((innerValue) => innerValue && innerValue.pt_session_objective_id === objectiveId);
          }
          return value && value.pt_session_objective_id === objectiveId;
        })
        .map((value) => {
          if (Array.isArray(value)) {
            return value
              .filter((innerValue) => innerValue && innerValue.pt_session_objective_id === objectiveId && innerValue.implementation)
              .map((innerValue) => {
                if (innerValue.implementation_code === 'OTHER' && innerValue.implementation_other) {
                  return `Other Implementation: ` + innerValue.implementation_other;
                }
                return innerValue.implementation;
              })
              .join(', ');
          } else {
            if (value.implementation_code === 'OTHER' && value.implementation_other) {
              return `Other Implementation: ` + value.implementation_other;
            }
            return value.implementation;
          }
        });

      return filteredValues.join(', ');
    },
    formatProgressMeasures(values, taskId) {
      if (!Array.isArray(values)) return '';

      const filteredValues = values.filter((measure) => measure.ptSessionTaskId === taskId);

      const formattedValues = filteredValues.map((measure) => {
        let valueText = '';
        if (measure.type === 'OUT_OF' && measure.value1 !== null && measure.value2 !== null) {
          valueText = `Completed ${measure.value1} out of ${measure.value2} tasks`;
        } else if (measure.type === 'OUT_OF' && (measure.value1 !== null && measure.value2 === null)) {
          valueText = `Completed ${measure.value1} tasks`;
        } else if (measure.type === 'OUT_OF' && (measure.value1 === null && measure.value2 !== null)) {
          valueText = `Completed ${measure.value2} tasks`;
        } else if (measure.type === 'MINUTES' && measure.value1 !== null) {
          valueText = `Completed task in ${measure.value1} minutes`;
        }
        else if (measure.type === 'ACCURACY' && measure.value1 !== null) {
          valueText = `Completed task with ${measure.value1}% accuracy`;
        }
        return valueText ? valueText : ``;
      });
      return formattedValues.join(', ');
    },
    formatProgressAssistance(values, taskId) {
      if (!Array.isArray(values)) return '';

      const filteredValues = values.filter((assistance) => assistance.ptSessionTaskId === taskId);

      const formattedValues = filteredValues.map((assistance) => {
        let valueText = '';
        if (assistance.type === 'OUT_OF' && assistance.value1 !== null && assistance.value2 !== null) {
          valueText = `Required assistance ${assistance.value1} out of ${assistance.value2} times`;
        } else if (assistance.type === 'OUT_OF' && (assistance.value1 !== null && assistance.value2 === null)) {
          valueText = `Required assistance ${assistance.value1} times`;
        } else if (assistance.type === 'OUT_OF' && (assistance.value1 === null && assistance.value2 !== null)) {
          valueText = `Required assistance ${assistance.value2} times`;
        } else if (assistance.type === 'MINUTES' && assistance.value1 !== null) {
          valueText = `Required assistance for ${assistance.value1} minutes`;
        }
        else if (assistance.type === 'PERCENT' && assistance.value1 !== null) {
          valueText = `Required assistance for ${assistance.value1}%`;
        }
        else if (assistance.type === 'NONE' && assistance.value1 === 'none') {
          valueText = `None`;
        }
        
        return valueText;
      });

      return formattedValues.join('\n');
    },
    formatProgressTypes(values, taskId) {
      if (!Array.isArray(values)) return '';

      const filteredValues = values.filter((type) => type.ptSessionTaskId === taskId);

      const formattedValues = filteredValues.map((type) => {
        let valueText = '';
        if (type.code !== 'OTHER' && type.checked === 'true') {
          valueText = `${type.assistType}`;
        } else if (type.code === 'OTHER' && type.checked === 'true') {
            if (type.assistType !== null) {
              valueText = `Other: ${type.assistType}`;
            }
            else {
              valueText = `Other`;
            }
          }

        return valueText;
      });

      return formattedValues.join(', ');
    }
  },
  filters: {
    createObjectiveStringFromArray(val) {
      if (!val || !val.length) return '';
      let string = '';
      for (let i = 0, l = val.length; i < l; i += 1) {
        string += val[i].objectiveDescription;
        if (i < (l - 1)) string += ', ';
      }
      return string;
    }
  },
  watch: {
    dialog() {
      this.loadPage();
    }
  }
};
</script>

<style lang="scss" scoped>
  .header-class {
    color: var(--v-secondary-base);
    padding-left: 10px;
  }

  .divider-class {
    margin: 15px 0;
  }

  .divider-half-class {
    margin-left: 75px;
    margin-right: 75px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .mobile {
    margin: 10px 0;
  }

  .desktop {
    margin-left: 35px;
  }

  .data-title {
    font-weight: bold;
    color: var(--v-primary-base);
  }

  .session-container {
    margin-top: 15px;
    .session-row {
      margin: 8px 0;
      .outcome-container {
        overflow-wrap: break-word;
      }
    }
  }

  #edit:hover {
    color: green;
  }

  #delete:hover {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/service-log/confirmation-page.vue